// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"3":"de73a413","122":"36250f7c","131":"3241071a","294":"d4e05fc8","432":"97f49987","640":"2de75639","753":"e6904aed","892":"41217b05","916":"b871a277","954":"7f2bf5ed"}[chunkId] + ".js";
};